// extracted by mini-css-extract-plugin
export default {"tabList":"Tabs_tabList__FyfAq","disabledTab":"Tabs_disabledTab__Paxla","tab":"Tabs_tab__3csgs"};